import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import {
  HighlightPopover,
  useHighlightPopover,
} from "@omsimos/react-highlight-popover";

function Popover() {
  const { currentSelection, setShowPopover } = useHighlightPopover();

  return (
    <button
      className="gradient-dark-button"
      onClick={() => (window.location.href = `/?title=${currentSelection}`)}
    >
      {currentSelection} ➡️
    </button>
  );
}

const fetchArticle = async (
  title: string,
  callback: (type: "error" | "success", value: string) => any
) => {
  try {
    const response = await fetch(`/api?title=${title}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const text = await response.text();
    callback("success", text);
  } catch (err) {
    callback(
      "error",
      err instanceof Error ? err.message : "An unknown error occurred"
    );
  }
};

const ArticleRenderer: React.FC = () => {
  const [article, setArticle] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const title = searchParams.get("title");

    fetchArticle(title || "cognipedia", (type, value) => {
      if (type === `success`) {
        setArticle(value);
      } else {
        setError(value);
      }
    });
  }, []);

  if (error) {
    return <div>Error loading article: {error}</div>;
  }

  if (!article) {
    return <div>Loading article...</div>;
  }

  return (
    <HighlightPopover renderPopover={() => <Popover />}>
      <ReactMarkdown>{article}</ReactMarkdown>
    </HighlightPopover>
  );
};

export default ArticleRenderer;
